import type { NullableType } from '@/types'

export enum DrawerType {
  INCIDENTS_INFO = 'INCIDENTS_INFO',
  PARK_INFO = 'PARK_INFO',
  FUEL_USE = 'FUEL_USE',
  MILEAGE = 'MILEAGE',
  CREATE_DRIVER_TASK = 'CREATE_DRIVER_TASK',
  CREATE_GAS_REGISTRIES = 'CREATE_GAS_REGISTRIES',
  ADD_COMPLETED_TASK = 'ADD_COMPLETED_TASK',
  EDIT_COMPLETED_TASK = 'EDIT_COMPLETED_TASK',
  EDIT_GAS_REGISTRIES = 'EDIT_GAS_REGISTRIES',
  VEHICLE_MODEL = 'VEHICLE_MODEL',
  DOCUMENT_CARD = 'DOCUMENT_CARD',
  EQUIPMENT_CARD = 'EQUIPMENT_CARD',
  CREATE_VEHICLE_CARD = 'CREATE_VEHICLE_CARD',
  CREATE_DRIVER_CARD = 'CREATE_DRIVER_CARD',
  ADDING_VEHICLE_DRAWER = 'ADDING_VEHICLE_DRAWER',
  //дрейверы модула  EditDictionarieVehicle
  EDIT_DICTIONARIE_VEHICLE__CREATE_CARD_DOCUMENT = 'EDIT_DICTIONARIE_VEHICLE__CREATE_CARD_DOCUMENT',
  EDIT_DICTIONARIE_VEHICLE__EDIT_CARD_DOCUMENT = 'EDIT_DICTIONARIE_VEHICLE__EDIT_CARD_DOCUMENT',
  EDIT_DICTIONARIE_VEHICLE__ADD_ORDER_ACT_CARD = 'EDIT_DICTIONARIE_VEHICLE__ADD_ORDER_ACT_CARD',
  EDIT_DICTIONARIE_VEHICLE__ADD_VEHICLE_DEPLOYMENT_ORDER = 'EDIT_DICTIONARIE_VEHICLE__ADD_VEHICLE_DEPLOYMENT_ORDER',
  // medcomplex
  CREATE_MEDCOMPLEX__CREATE_VERIFICATION_DOCUMENT = 'CREATE_MEDCOMPLEX__CREATE_VERIFICATION_DOCUMENT',
  // organization
  ORGANIZATION_BANK_ACCOUNT = 'ORGANIZATION_BANK_ACCOUNT',
  EDIT_BRANCH = 'EDIT_BRANCH',
  // employee
  EMPLOYEE_DOCUMENT = 'EMPLOYEE_DOCUMENT',
}

export enum ModalType {
  // medcomplex
  MEDCOMPLEX_COMPLETE_GENERAL = 'MEDCOMPLEX_COMPLETE_GENERAL',
  MEDCOMPLEX_COMPLETE_CERTIFICATE = 'MEDCOMPLEX_COMPLETE_CERTIFICATE',
  MEDCOMPLEX_COMPLETE_CONFIG = 'MEDCOMPLEX_COMPLETE_CONFIG',
  // organization
  ORGANIZATION_COMPLETE_GENERAL = 'ORGANIZATION_COMPLETE_GENERAL',
  ORGANIZATION_COMPLETE_BANK_ACCOUNT = 'ORGANIZATION_COMPLETE_BANK_ACCOUNT',
  ORGANIZATION_CHANGE = 'ORGANIZATION_CHANGE',
  // employee
  EMPLOYEE_COMPLETE_GENERAL = 'EMPLOYEE_COMPLETE_GENERAL',
  EMPLOYEE_COMPLETE_INVITE = 'EMPLOYEE_COMPLETE_INVITE',
  EMPLOYEE_COMPLETE_ROLE = 'EMPLOYEE_COMPLETE_ROLE',
  EMPLOYEE_COMPLETE_DOCUMENT = 'EMPLOYEE_COMPLETE_DOCUMENT',
  EMPLOYEE_FIRE = 'EMPLOYEE_FIRE',
  EMPLOYEE_COINCIDENCE = 'EMPLOYEE_COINCIDENCE',
  EMPLOYEE_RESTORE = 'EMPLOYEE_RESTORE',
  EMPLOYEE_BLOCK = 'EMPLOYEE_BLOCK',
  EMPLOYEE_UNBLOCK = 'EMPLOYEE_UNBLOCK',
  SUBDIVISION_APPOINTMENT = 'SUBDIVISION_APPOINTMENT',
  // notifications
  MEDCOMPLEX_CERTIFICATE_NOTIFICATION = 'MEDCOMPLEX_CERTIFICATE_NOTIFICATION',
  // medreports
  REPORT_ERROR = 'REPORT_ERROR',
}

export type Role =
  | 'Администратор Тетрон'
  | 'Техподдержка Тетрон'
  | 'Администратор интегратора'
  | 'Техподдержка интегратора'
  | 'Администратор клиента'
  | 'Руководитель (НТЦ)'
  | 'Руководитель (Менеджер)'
  | 'Диспетчер'
  | 'Водитель'
  | 'Мед. осматриваемый'
  | 'Старший медик'
  | 'Медик'

export type Product =
  | 'MAIN'
  | 'WAYBILL'
  | 'ORGANIZATION'
  | 'MEDCOMPLEX'
  | 'MEDEXAM'
  | 'CLIENTS'
  | 'TECHINSPECT'
  | 'ANALYTICS'
  | 'MEDORGANIZATION'
  | 'HELP'
  | 'ANALYTICS_FUEL'
  | 'ANALYTICS_MILEAGE'
  | 'ANALYTICS_MEDEXAMRESULTS'
  | 'ANALYTICS_MEDICLOAD'
  | 'ANALYTICS_MEDICWORK'
  | 'INSPECTIONS'
  | 'REPORTS'
  | 'SHIFTSCHEDULE'
  | 'MYDOCUMENTS'

export type Access =
  | 'READ'
  | 'UPDATE'
  | 'CREATE'
  | 'DELETE'
  | 'ADMIN'
  | 'ADMIN_CLIENT'

export const RoleAccess: Record<string, Access[]> = {
  'Администратор Тетрон MAIN': ['READ'],
  'Администратор Тетрон WAYBILL': ['READ', 'UPDATE', 'CREATE', 'ADMIN'],
  'Администратор Тетрон ORGANIZATION': [
    'READ',
    'UPDATE',
    'CREATE',
    'DELETE',
    'ADMIN',
  ],
  'Администратор Тетрон MEDCOMPLEX': ['READ', 'UPDATE', 'CREATE', 'ADMIN'],
  'Администратор Тетрон MEDEXAM': ['READ', 'UPDATE', 'CREATE', 'ADMIN'],
  'Администратор Тетрон CLIENTS': ['READ'],
  'Администратор Тетрон TECHINSPECT': ['READ'],
  'Администратор Тетрон ANALYTICS': ['READ'],
  'Администратор Тетрон MEDORGANIZATION': ['READ'],
  'Администратор Тетрон HELP': ['READ'],
  'Администратор Тетрон ANALYTICS_FUEL': ['READ'],
  'Администратор Тетрон ANALYTICS_MILEAGE': ['READ'],
  'Администратор Тетрон ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Техподдержка Тетрон MAIN': ['READ'],
  'Техподдержка Тетрон WAYBILL': ['READ', 'CREATE', 'UPDATE'],
  'Техподдержка Тетрон ORGANIZATION': ['READ', 'CREATE'],
  'Техподдержка Тетрон MEDCOMPLEX': ['READ', 'UPDATE', 'CREATE'],
  'Техподдержка Тетрон MEDEXAM': ['READ', 'UPDATE'],
  'Техподдержка Тетрон CLIENTS': ['READ'],
  'Техподдержка Тетрон TECHINSPECT': ['READ'],
  'Техподдержка Тетрон ANALYTICS': ['READ'],
  'Техподдержка Тетрон MEDORGANIZATION': ['READ'],
  'Техподдержка Тетрон HELP': ['READ'],
  'Техподдержка Тетрон ANALYTICS_FUEL': ['READ'],
  'Техподдержка Тетрон ANALYTICS_MILEAGE': ['READ'],
  'Техподдержка Тетрон ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Администратор интегратора MAIN': ['READ'],
  'Администратор интегратора WAYBILL': ['READ'],
  'Администратор интегратора ORGANIZATION': ['READ', 'UPDATE', 'CREATE'],
  'Администратор интегратора MEDCOMPLEX': ['READ', 'UPDATE'],
  'Администратор интегратора CLIENTS': ['READ'],
  'Администратор интегратора ANALYTICS': ['READ'],
  'Администратор интегратора HELP': ['READ'],
  'Администратор интегратора ANALYTICS_FUEL': ['READ'],
  'Администратор интегратора ANALYTICS_MILEAGE': ['READ'],
  'Администратор интегратора ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Техподдержка интегратора MAIN': ['READ'],
  'Техподдержка интегратора WAYBILL': ['READ'],
  'Техподдержка интегратора ORGANIZATION': ['READ', 'UPDATE', 'CREATE'],
  'Техподдержка интегратора MEDCOMPLEX': ['READ', 'UPDATE'],
  'Техподдержка интегратора CLIENTS': ['READ'],
  'Техподдержка интегратора ANALYTICS': ['READ'],
  'Техподдержка интегратора HELP': ['READ'],
  'Техподдержка интегратора ANALYTICS_FUEL': ['READ'],
  'Техподдержка интегратора ANALYTICS_MILEAGE': ['READ'],
  'Техподдержка интегратора ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Администратор клиента MAIN': ['READ'],
  'Администратор клиента WAYBILL': ['READ', 'UPDATE', 'CREATE'],
  'Администратор клиента ORGANIZATION': [
    'ADMIN_CLIENT',
    'READ',
    'UPDATE',
    'CREATE',
  ],
  'Администратор клиента MEDCOMPLEX': ['READ'],
  'Администратор клиента MEDEXAM': ['READ'],
  'Администратор клиента ANALYTICS': ['READ'],
  'Администратор клиента HELP': ['READ'],
  'Администратор клиента ANALYTICS_FUEL': ['READ'],
  'Администратор клиента ANALYTICS_MILEAGE': ['READ'],
  'Администратор клиента ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Руководитель (НТЦ) MAIN': ['READ'],
  'Руководитель (НТЦ) WAYBILL': ['READ'],
  'Руководитель (НТЦ) ORGANIZATION': ['READ', 'CREATE'],
  'Руководитель (НТЦ) MEDCOMPLEX': ['READ'],
  'Руководитель (НТЦ) MEDEXAM': ['READ'],
  'Руководитель (НТЦ) ANALYTICS': ['READ'],
  'Руководитель (НТЦ) HELP': ['READ'],
  'Руководитель (НТЦ) ANALYTICS_FUEL': ['READ'],
  'Руководитель (НТЦ) ANALYTICS_MILEAGE': ['READ'],
  'Руководитель (НТЦ) ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Руководитель (Менеджер) MAIN': ['READ'],
  'Руководитель (Менеджер) WAYBILL': ['READ'],
  'Руководитель (Менеджер) ORGANIZATION': ['READ'],
  'Руководитель (Менеджер) MEDCOMPLEX': ['READ'],
  'Руководитель (Менеджер) MEDEXAM': ['READ'],
  'Руководитель (Менеджер) ANALYTICS': ['READ'],
  'Руководитель (Менеджер) HELP': ['READ'],
  'Руководитель (Менеджер) ANALYTICS_FUEL': ['READ'],
  'Руководитель (Менеджер) ANALYTICS_MILEAGE': ['READ'],
  'Руководитель (Менеджер) ANALYTICS_MEDEXAMRESULTS': ['READ'],

  'Диспетчер MAIN': ['READ'],
  'Диспетчер WAYBILL': ['READ', 'UPDATE', 'CREATE'],
  'Диспетчер ORGANIZATION': ['READ', 'CREATE'],
  'Диспетчер ANALYTICS': ['READ'],
  'Диспетчер ANALYTICS_FUEL': ['READ'],
  'Диспетчер ANALYTICS_MILEAGE': ['READ'],
  'Диспетчер HELP': ['READ'],

  'Водитель MAIN': ['READ'],
  'Водитель ORGANIZATION': ['READ', 'CREATE'],
  'Водитель HELP': ['READ'],

  'Мед. осматриваемый MAIN': ['READ'],
  'Мед. осматриваемый ORGANIZATION': ['READ', 'CREATE'],
  'Мед. осматриваемый HELP': ['READ'],

  'Старший медик MAIN': ['READ'],
  'Старший медик ORGANIZATION': ['READ', 'CREATE'],
  'Старший медик MEDEXAM': ['UPDATE'],
  'Старший медик ANALYTICS': ['READ'],
  'Старший медик ANALYTICS_MEDICLOAD': ['READ'],
  'Старший медик ANALYTICS_MEDICWORK': ['READ'],
  'Старший медик MEDORGANIZATION': ['READ'],
  'Старший медик HELP': ['READ'],

  'Медик INSPECTIONS': ['READ'],
  'Медик REPORTS': ['READ'],
  'Медик SHIFTSCHEDULE': ['READ'],
  'Медик MYDOCUMENTS': ['READ'],
}

export interface Moment {
  location: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any | null
}

export interface AppState {
  drawerOpened: NullableType<DrawerType>
  modalOpened: NullableType<ModalType>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  employee: any | null
  baseUrl: string | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userCompanies: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activeCompany: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  menuAccess: any | null
  userRoles: string[] | null
  history: Moment[] | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  medJournalAwaiting: any | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  employeesImportNotification: any | null
  activeHasBranches: boolean | null
  currentHasBranches: boolean | null
}

//export type Access = 'READ' | 'UPDATE' | 'CREATE' | 'DELETE' | 'ADMIN'

export interface MenuItem {
  title?: string
  icon?: string
  url?: {
    pathname: string
    access: Access[]
  }
  subLinks?: MenuItem[]
}
